import { CircularProgress, IconButton, Tooltip, type IconButtonProps, type SvgIconProps } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Colors } from '@rentguru/commons-utils';
import { CSSProperties, forwardRef } from 'react';

import { stopPropagation } from '../../utils';

const actionIconButtonSecondStyles = makeStyles({
  root: {
    height: 35,
    color: Colors.DARK_SLATE_GREY,
    background: Colors.CLASSICAL_WHITE,
    borderRadius: 60,
    borderCollapse: 'collapse',
    boxShadow: '0px 3px 10px 0px rgba(0,0,0,0.1)',
    padding: '5px 15px',
    marginRight: 10,
  },
});

interface actionIconButtonProps extends IconButtonProps {
  tooltip?: string;
  href?: string;
  target?: string;
  iconStyle?: CSSProperties;
}

export interface BaseActionIconButtonPropsProps extends actionIconButtonProps {
  Icon: React.FC<SvgIconProps> | React.FC<React.SVGProps<SVGSVGElement>> | typeof CircularProgress;
}

// eslint-disable-next-line react/display-name
export const ActionIconButton = forwardRef<HTMLButtonElement, BaseActionIconButtonPropsProps>(
  ({ iconStyle, Icon, tooltip, ...rest }, ref) => {
    const classes = actionIconButtonSecondStyles();
    return (
      <Tooltip title={tooltip ?? ''} placement="bottom">
        <IconButton className={classes.root} onMouseDown={stopPropagation} ref={ref} {...rest}>
          <Icon style={iconStyle} />
        </IconButton>
      </Tooltip>
    );
  }
);
